export default "__VITE_ASSET__Msi$WLUI__";